import { useEffect, useRef } from "react";
import { useLocation, useNavigate, matchPath } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/FirebaseCredential";
import { ROUTES } from "../routes/routesPaths";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/FirebaseCredential";

function useLiveBenchProfileCheck(userId: unknown, debounceTime = 200) {
  const location = useLocation();
  const navigate = useNavigate();
  const benchDataRef = useRef<any>(null);
  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!userId) return;

    const benchprofileDocRef = doc(db, "benchprofile", String(userId));

    // Attach listener once
    const unsubscribe = onSnapshot(
      benchprofileDocRef,
      (docSnap) => {
        if (!docSnap.exists()) return;

        benchDataRef.current = docSnap.data();
        handleRouteChange(location.pathname);
      },
      (error) => console.error("Error listening to benchprofile:", error)
    );

    return () => unsubscribe();
  }, [userId]);

  // Handle route changes
  useEffect(() => {
    if (benchDataRef.current) {
      handleRouteChange(location.pathname);
    }
  }, [location.pathname]);

  const handleRouteChange = (pathname: string) => {
    const excludedRoutes = [
      ROUTES.CHOOSE_COMPANY_TYPE,
      ROUTES.COMPANY_REGISTER_WIZARD,
      ROUTES.MAP_BRANCHES_TO_COMPANY,
      ROUTES.COMPANY_REGISTRATION_MODAL,
      ROUTES.SUBSCRIPTION_PAGE,
      ROUTES.NEW_SUBSCRIPTION_PAGE,
      ROUTES.PAYMENT_PAGE,
      ROUTES.PAYMENT_SUCCESS_PAGE,
      ROUTES.MEMBER_PAYMENT_SUCCESS_PAGE,
      ROUTES.PAYMENT_FAILED_PAGE,
    ];

    const normalizePath = (path: string) =>
      path.replace(/\/$/, "").split("?")[0];
    const currentPath = normalizePath(pathname);

    const isExcluded = excludedRoutes.some((pattern) => {
      // Remove optional param from pattern
      const cleanedPattern = pattern.replace(/\/:.*\?$/, "");
      const regex = new RegExp(`^${cleanedPattern}(/.*)?$`);
      const match = regex.test(currentPath);
     
      return match;
    });
    // console.log("Is current route excluded?", isExcluded);

    if (isExcluded) return;

    // Debounce the logout action
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      if (benchDataRef.current.company_reg_completed === false) {
        await signOut(auth);

        navigate("/");
      }
    }, debounceTime);
  };
}

export default useLiveBenchProfileCheck;
